import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";

export interface GetInstagramPostsResponse {
  status: "Failed" | "Success";
  posts?: InstagramPost[];
}

export interface InstagramPost {
  permalink: string;
  imageUrl: string;
}

export const getInstagramPosts = (core: XcoreCore, timeout?: number): BaseApiRequest<GetInstagramPostsResponse> =>
  core
    .fetch("/api/instagram", { timeout })
    .then((res) => res.json())
    .then((res: GetInstagramPostsResponse) => {
      if (res.status === "Success" && res?.posts) {
        return {
          status: res.status,
          // Api EP is passed forward directly from instagram
          // and its response has additional fields that aren't needed so it is safer to sanitize the res here
          posts: res.posts.map(({ permalink, imageUrl }) => ({ permalink, imageUrl })),
        };
      }

      return res;
    });
